module.exports = __webpack_public_path__ + "static/media/payroll.65ce6f05.svg";